import { FC } from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export interface IRouteErrorBoundaryProps {}

export const RouteErrorBoundary: FC = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <>
        <h1>
          {error.status} {error.statusText}
        </h1>
        <p>{error.data}</p>
      </>
    );
  } else if (error instanceof Error) {
    throw error;
  } else {
    return <h1>Unknown Error</h1>;
  }
};
